export const NON_COOPERATION_REASON_OPTIONS = [
  {
    code: 'missing_signed_loa',
    label: 'Provide a signed Letter of Authority',
  },
  {
    code: 'missing_id_or_address',
    label: 'Provide Proof of Identification and/or Address',
  },
  {
    code: 'missing_identity_or_vehicle_information',
    label: 'Provide clarification or further information relating to your name (including any previous names), address (including any previous addresses), date of birth, email address, telephone number, or vehicle make, model or registration',
  },
  {
    code: 'missing_joint_account_holder_information',
    label: 'Provide Joint Account Holder Information',
  },
  {
    code: 'sole_representative_confirmation_required',
    label: 'Contact your lender(s) to confirm our instruction as your sole representative and cancel all other legal representatives',
  },
  {
    code: 'proceed_or_cancel_confirmation_required',
    label: 'Confirm whether you wish to proceed with Complex Law or cancel your claims with Complex Law',
  },
  {
    code: 'missing_deceased_client_documents',
    label: 'Provide documentation relating to a deceased client (for example, a death certificate, will, Grant of Probate or Letters of Administration)',
  },
  {
    code: 'clear_instructions_required',
    label: 'Provide clear and reasonable instructions',
  },
  {
    code: 'requested_documents_or_information_missing',
    label: 'Provide requested documentation and/or information',
  },
] as const;

export type NonCooperationReasonCode = typeof NON_COOPERATION_REASON_OPTIONS[number]['code'];

